import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const MortalityMobidityChartsDataContext = createContext();

const MortalityMobidityChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.MORTALITY_MOBIDITY_RESULTS,
            url: 'governanceroom/dashboard/vitalstatistics/results/mortality-mobidity',
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  childrenMortality: data?.indicators?.childrenMortality ?? 0,
                  infantAndFetalMortality:
                      data?.indicators?.infantAndFetalMortality ?? 0,
                  prematureNewborns: data?.indicators?.prematureNewborns ?? 0,
                  earlyNeonatalMortality:
                      data?.indicators?.earlyNeonatalMortality ?? 0,
                  lateNeonatalMortality:
                      data?.indicators?.lateNeonatalMortality ?? 0,
                  postNeonatalMortality:
                      data?.indicators?.postNeonatalMortality ?? 0,
                  deathsOfWomenOfChildbearingAge:
                      data?.indicators?.deathsOfWomenOfChildbearingAge ?? 0,
                  mothersDeaths: data?.indicators?.mothersDeaths ?? 0,
                  tenagerMothers: data?.indicators?.tenagerMothers ?? 0
              },
              liveBirthsMothersAge: data?.liveBirthsMothersAge ?? [],
              deathMothersAge: data?.deathMothersAge ?? []
          }
        : {
              indicators: {
                  childrenMortality: 0,
                  infantAndFetalMortality: 0,
                  prematureNewborns: 0,
                  earlyNeonatalMortality: 0,
                  lateNeonatalMortality: 0,
                  postNeonatalMortality: 0,
                  deathsOfWomenOfChildbearingAge: 0,
                  mothersDeaths: 0,
                  tenagerMothers: 0
              },
              liveBirthsMothersAge: [],
              deathMothersAge: []
          };

    return (
        <MortalityMobidityChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </MortalityMobidityChartsDataContext.Provider>
    );
};

export default MortalityMobidityChartsDataProvider;
